import { useCallback, useEffect, useState } from 'react';
import {
  fetchSchoolHomePageData,
  getStatFromMap,
  SCHOOL_HOME_PAGE_STAT_LABELS,
} from '../utils/schoolHomePageStats';

const useSchoolHomePageStats = () => {
  const [statsMap, setStatsMap] = useState({});
  const [pricingPlans, setPricingPlans] = useState([]);
  const [pricingStatus, setPricingStatus] = useState('loading');
  const [reloadToken, setReloadToken] = useState(0);

  const reloadPricing = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setPricingStatus('loading');

    fetchSchoolHomePageData(controller.signal)
      .then(({ statsMap: nextStatsMap, pricingPlans: nextPricingPlans, pricingUnavailable }) => {
        setStatsMap(nextStatsMap);
        setPricingPlans(nextPricingPlans);
        setPricingStatus(pricingUnavailable ? 'error' : 'ready');
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.error('School home page API:', err.message);
        setPricingPlans([]);
        setPricingStatus('error');
      });

    return () => controller.abort();
  }, [reloadToken]);

  const getStat = useCallback(
    (label) => getStatFromMap(statsMap, label),
    [statsMap],
  );

  const schoolsCount = getStat(SCHOOL_HOME_PAGE_STAT_LABELS.totalSchools);

  return { statsMap, getStat, schoolsCount, pricingPlans, pricingStatus, reloadPricing };
};

export default useSchoolHomePageStats;
